export default __webpack_public_path__ + "static/media/aboutMe.f24b6ad2.svg";